export default {
    xml: {
        'PplInterv': {
            'SotrName':               'Сотрудник',
            'SotrKey':                'Код сотрудника',
            'AlsoParticipated':       'Также участвовали',
            'Candidate':              'Кандидат',
            'CandKey':                'Код кандидата',
            'PersonalAppearance':     'Внешний вид',
            'PersonalQualities':      'Личные качества',
            'ProfessionalMotivation': 'Профессиональная мотивация',
            'ProfessionalExperience': 'Профессиональный опыт, личные достижения',
            'IntDate':                'Дата проведения интервью',
            'LanguageSkills':         'Владение иностранными языками',
            'DifFromCV':              'Отличия резюме от реального опыта, пропуски в карьере',
            'WantSalary':             'Зарплата, пакет и ожидания',
            'JobSearchHistory':       'История поиска работы',
            'WherePresent':           'Куда буду/не буду представлять',
            'WhereEfficient':         'Позиции, на которых кандидат может быть эффективен',
            'DopInfo':                'Дополнительная информация',
            'DocumentLettersUpdate':  'введено сиволов:'
        },
        'PplPhoneInterv': {
            'REKR':                  'Сотрудник',
            'REKRKEY':               'Код сотрудника',
            'CAND':                  'Кандидат',
            'CANDKEY':               'Код кандидата',
            'INTDATE':               'Дата проведения интервью',
            'JobExperience':         'Опыт работы, занимаемая должность и обязанности',
            'ForeignLanguage':       'Владение иностранным языком',
            'DrivingLicense':        'Водительские права, наличие автомобиля',
            'Education':             'Образование, специальные навыки',
            'PCSkills':              'Владение PC',
            'WhatJobIsInterested':   'Какая работа интересна',
            'JobSearchHistory':      'История поиска работы',
            'SalaryExpectations':    'Зарплатные ожидания, компенсационный пакет',
            'LocationRequirements':  'Требования к местоположению',
            'AdditionalInformation': 'Дополнительная информация',
            'PersonalImpressions':   'Личные впечатления',
            'ConverationOutcome':    'Выводы по результатам собеседования',
            'PcSkills':              'Навыки работы с компьютером',
            'Motivation':            'Мотивация кандидата',
            'Experience':            'Профессиональный опыт и знания',
            'createdate':            'Дата заполнения',
            'sekrfio':               'Секретарь по вводу информации',
            'sekrdate':              'Дата',
            'sekrworkname':          'Выполнил(а) работу:',
        },
        'PplSomeForm': {
            'Text': 'Текст'
        },
        'PplVerRek': {
            'Employee':               'Сотрудник',
            'Candidate':              'Кандидат',
            'POS':                    'Позиция, на которую проводится проверка рекомендаций',
            'REKOMFIO':               'Рекомендатель',
            'REKOMCOMP':              'Настоящее место работы рекомендателя',
            'REKOMDOLG':              'Должность рекомендателя',
            'REKOMPHONE':             'Телефон/электронная почта рекомендателя',
            'HOWLONGKNOW':            'Как давно Вы с ним знакомы?',
            'YOUDECIDEPRIM':          'Кто принимал решение о его найме?',
            'YOUDECIDEPRIM_FORM':     '(если говорим с руководителем) Кто принимал решение о его найме?',
            'WHENWORK':               'В какое время и в какой компании (-ях) Вы с ним работали?',
            'VERREKDATE':             'Дата проверки рекомендаций',
            'WASREKCHIEF':            'Скажите, Вы были его руководителем? Коллегой? Подчиненным?',
            'WHATTASK':               'Какие задачи он решал? Какую работу выполнял?',
            'WHATFUNC':               'Какими были его основные функции во время Вашей совместной работы?',
            'REKNAME':                'Какую должность занимали Вы и он во время совместной работы?',
            'MARK':                   'Как Вы оцениваете его результаты: что удалось достичь за период работы на этой позиции? Критерии его эффективности',
            'ACHIEVE':                'Что Вы могли бы выделить как его основные достижения?',
            'DIF':                    'С какими задачами ему не удалось/не удавалось справиться?',
            'VKLAD':                  'Каков был его личный вклад в результат всей команды?',
            'RESULT':                 'Как бы Вы оценили его результаты по сравнению с поставленными целями?',
            'CMPRESULT':              'Как бы Вы оценили его результаты работы по сравнению с результатами других сотрудников на аналогичных позициях?',
            'HOWWORK':                'Как Вы оцениваете его отношение к работе? (переработки, дисциплина). Был ли он надёжным сотрудником?',
            'WHATOUTFAKTOR':          'Что является для него главным стимулом в работе?',
            'STIMUL':                 'Какие рабочие ситуации являлись для него стрессовыми? Как это проявлялось? Как он с ними справлялся?',
            'WHYSTESS':               'Были ли какие-нибудь факторы вне работы, влиявшие на его результаты? (аккуратно и деликатно спрашиваем про возможные вредные привычки, болезни, семейные ситуации, которые влияли на работу)',
            'STRONG':                 'Каковы, на Ваш взгляд, его сильные стороны?',
            'STRONG_FORM':            'Каковы, на Ваш взгляд, его сильные стороны? (что еще?)',
            'NOTSTRONG':              'Какие качества ему следует развивать, что бы быть более успешным в работе?',
            'WITHCHIEF':              'Как у него складываются (-лись) отношения в коллективе (с коллегами, подчиненными, руководством)? Является ли он командным игроком?',
            'WITHOUT':                'Как складывались отношения с клиентами и поставщиками (если работал с ними)?',
            'WHATCHIEF':              'Как Вы могли бы охарактеризовать его как руководителя? Как он строил отношения с подчиненными?',
            'WASCHIEF':               'Сколько человек было в его подчинении? Прямом/косвенном? Что это был за персонал?',
            'WASSAMOST':              'Приходилось ли ему принимать самостоятельные/непопулярные решения? Какие? Каковы были последствия?',
            'WASTRUDO':               'Принимал ли он лично решение о найме/увольнении людей? Насколько охотно он брал на себя ответственность за действия команды?',
            'WITHKOLLEGA':            'Возникали ли сложные ситуации, конфликты в работе с коллегами/подчинёнными/руководством? В чем они заключались? Какую позицию он в них занимал?',
            'WHYGO':                  'Как Вы думаете, почему он был уволен/покинул Вашу компанию? Кто принимал решение о его увольнении?',
            'WANTHIMCOMMENT':         'Взяли бы Вы его снова на работу? Почему?',
            'WANTHIMCOMMENT_FORM':    '(для руководителя) Взяли бы Вы его снова на работу? Почему?',
            'ADDINFORM':              'Могли бы Вы добавить что-либо еще, о чем я не спросил?',
            'WHYYOUREKOM':            'Как Вы думаете, сможет ли он выполнять эту работу? Что помогло бы мне правильно оценить его квалификацию и способности?',
            'WHATFUTURECHIEF':        'Каким должен быть его руководитель, чтобы он был максимально эффективен?',
            'WHUWILLGO':              'В чем причина его ухода/желания уйти из компании? Как руководство/сотрудники отреагировали (-уют) на его уход/увольнение?',
            'WANTHIMKOLLEGA':         'Хотели бы Вы (готовы ли Вы) опять с ним работать? Почему?',
            'WANTHIMKOLLEGA_FORM':    '(для коллеги, подчиненного) Хотели бы Вы (готовы ли Вы) опять с ним работать? Почему?',
            'ADDQUESTION':            '«Свой» доп. вопрос или специфический вопрос линейного менеджера',
            'WHATREKOTN':             'Какие отношения у Вас складывались с ним?',
            'HOWLONGSTART':           'Как быстро человек влился в коллектив? Стал эффективным сотрудником?',
            'CLIENTFIO':              'ФИО линейного менеджера',
            'CLIENTFIO_FORM':         'ФИО заказчика рекомендации',
            'CLIENTCOMP':             'Компания',

            'generalInfo':            'Общая информация',
            'collaborationPeriod':    'Период совместной работы',
            'subordinationSystem':    'Cиситема подчинения «кандидат/рекомендатель»',
            'mainTasks':              'Основные задачи и функции кандидата',
            'workResults':            'Результаты работы и достижения',
            'strengths':              'Сильные стороны',
            'peopleManagement':       'Руководство людьми (для руководящих позиций)',
            'weakSides':              'Слабые стороны и области для развития',
            'peopleRelationships':    'Отношения с людьми',
            'workAttitude':           'Отношение к работе',
            'futurеLeader':           'Будущий руководитель',
            'leavingReasons':         'Причины увольнения/желания рассматривать',
            'desireAgainWork':        'Желание работать с кандидатом снова',
            'futureWorkCompliance':   'Соответствие будущей работе',
            'candidateAdditionalinfo':'Дополнительная информация о кандидате',
            'yourAdditionalQuestion': '«Свой» доп. вопрос или специфический вопрос линейного менеджера',
            'documentResponsible':    'Ответственный за документ',
            'recomFio':               'Фамилия И.О.',
        },
        'MrktCall': {
            'SOTRKEY':               'Код сотрудника',
            'SOTRNAME':              'Сотрудник',
            'PPLKEY':                'Код сотрудника клиента',
            'PPLNAME':               'Сотрудник клиента',
            'ORGNAME':               'Название компании клиента',
            'ORGKEY':                'Код компании клиента',
            'DATE':                  'Дата',
            'PPLDOLG':               'Должность сотрудника клиента',
            'ABOUTSPEAK':            'Содержание разговора',
            'SIGN':                  'Впечатления о собеседнике и доп.информация',
            'RESULT':                'О чем договорились? (Результат контакта)',
            'TYPE':                  'Тип маркетингового контакта',
            'TARGET':                'Цель маркетингового контакта',
            'ADDANCORSOTR':          'Участвовали также сотрудники',
            'ADDZAKSOTR':            'Участвовали также сотрудники клиента',
            'ORGKATEGOR':            'Категория клиента',
            'INFABOUT':              'Источник информации для маркетинга',
            'NEXTDATE':              'Дата следующего контакта',
            'TARGETDESCR':           'Цель следующего контакта',
            'NEXCTCNT_OBJECTIVESTR': 'Цель следующего контакта (кратко)',
            'NEXTCNTTYPEST':         'Тип следующего контакта',
            'CNTOBJECTIVESTR':       'Цель контакта (кратко)',
            'CNTRESULTSTR':          'Результат контакта (кратко)',
            'NEXTCNT_SOTRKEY':       'Код сотрудника следующего контакта',
            'NEXTCNT_SOTRNAME':      'Сотрудник (следующий контакт)'
        },
        'PplZakInterv': {
            'INTDATE':  'Дата интервью',
            'CANDNAME': 'Кандидат',
            'ZAKNAME':  'Контактное лицо',
            'POSNAME':  'Позиция',
            'ZAKINFO':  'Информация от контактного лица',
            'CONTINFO':  'Информация (%(label)s)',
            'CANDINFO': 'Информация от кандидата'
        },
        'IntRecrRequest': {
            'request_date':             'Дата запроса',
            'posname':                  'Название позиции',
            'prjtype':                  'Тип проекта',
            'whomarket':                'Активный маркетинг',
            'zakazdepartkey':           'Отдел',
            'otvkey':                   'Ответственный',
            'orgname':                  'Компания',
            'numeqpos':                 'Количество позиций',
            'town':                     'Город',
            'is_budget':                'Наличие в бюджете',
            'posreason':                'Причина возникновения',
            'replace_ppl':              'Замещаемый сотрудник',
            'deadline':                 'Закрыть до',
            'salary':                   'Оклад мин',
            'salaryvaluta':             'Валюта',
            'salarybudgeted':           'Оклад макс',
            'split':                    'Бонусы и социальный пакет',
            'gonorar_fix':              'Гонорар (фикс. вознаграждение)',
            'grossnet':                 'До / После НДФЛ',
            'probation':                'Испытательный срок',
            'typeofexpirience':         'Стаж',
            'agefrom':                  'Возраст от',
            'ageto':                    'Возраст до',
            'sex':                      'Пол',
            'workplace':                'Место работы',
            'chartofwork':              'График работы',
            'typeofemployment':         'Тип занятости',
            'typeofeducation':          'Образование',
            'education':                'Комментарий к образованию',
            'experiencefunctions':      'Требования к опыту',
            'responsibilities':         'Обязанности',
            'personality':              'Личные качества',
            'language':                 'Иностранные языки',
            'ppl_zakaz':                'Заказчик',
            'town_code':                'Город (код)',
            'budget_code':              'Наличие в бюджете (код)',
            'posreason_code':           'Причина возникновения (код)',
            'replace_ppl_code':         'Замещаемый сотрудник (код)',
            'department_code':          'Отдел (код)',
            'department':               'Отдел',
            'salaryvaluta_code':        'Валюта (код)',
            'gonorar_type_valuta_code': 'Валюта гонорара (код)',
            'grossnet_code':            'До / После НДФЛ (код)',
            'typeofexpirience_code':    'Стаж (код)',
            'sex_code':                 'Пол (код)',
            'workplace_code':           'Место работы (код)',
            'chartofwork_code':         'График работы (код)',
            'typeofemployment_code':    'Тип занятости (код)',
            'typeofeducation_code':     'Образование (код)',
            'ppl_zakaz_code':           'HR-менеджер',
            'datefrom':                 'Дата отправки',
            'mainprim':                 'Дополнительная информация',
            'price':                    'Цена',
            'finprim':                  'Дополнительные условия',
            'kadryorgkey':              'Юридическое лицо заказчика',
            'kadryanckey':              'Юридическое лицо исполнителя',
            'valuta':                   'Валюта',
            'otvcfo':                   'Ответственный за ЦФО',
            'classifstr':               'Классификатор',
            'PosAlterName':             'Альтернативное название',
            'name':                     'Язык',
            'level':                    'Уровень владения',
            'LICENSE':                  'Права',
            'BUSINESS_TRIPS_STR':       'Командировки',
            'BUSINESS_TRIPS_PERCENT':   'Командировки (%)'
        },
        'ZakazComment': {
            'SOTRNAME': 'Сотрудник',
            'DATE': 'Дата заполнения',
            'COMMENT': 'Комментарий',
            'KATEGORCOMMENT': 'Комментарии при смене категории',
            'DONECOMMENT': 'Комментарии при выходе людей на работу',
            'Company': 'Проект',
            'ANNULCOMMENT': 'Комментарии при аннулировании проекта',
            'MAINCOMMENT': 'Комментарий по ходу работы над проектом'
        },
        'PosDescr': {
            'ZAKORGNAME': 'Компания - клиент',
            'POSNAME': 'Название позиции',
            'NUMEQPOS': 'число одинаковых позиций',
            'FROMDATE': 'Начало работы',
            'ANCGON': 'Гонорар АНКОРа',
            'ISPNAME': 'Исполнитель позиции',
            'TOWN': 'Город',
            'HISTORY': 'История позиции',
            'WHATWILLDO': 'Статус, задачи и обязанности сотрудника',
            'OPYT': 'Опыт работы(сфера бизнеса, конкретные компании, содержание работы, продолжительность, результаты)',
            'KVALIF': 'Наличие специального опыта и навыков в т.ч. работы со спецоборудовнием, квалификаций, сертификатов, допусков',
            'EDU': 'Образование(какие ВУЗы необходимы/желательны), готовность рассматривать студентов',
            'FORLANG': 'Знание иностранных языков(уровеньб использование) Оценка (10 - носитель языка, 0 - отсутствие знания)',
            'LICHNYE': 'Личные качества',
            'FINANSY': 'Финансовые условия найма',
            'NOFINANSY': 'Нефинансовые условия найма',
            'HOWOTBOR': 'Процесс отбора кандидатов',
            'ADDINFORM': 'Дополнения',
            'MAYBEKONKURENT': 'Готовы ли рассматривать из конкурентов',
            'NOCOMPANY': 'Компании, опыт в которых нежелателен, почему',
            'PC': 'Навыки работы на PC, владение программами.Уровень машинописи',
            'REGION': 'Готовы ли рассматривать кандидатов из других регионов',
            'ADD': 'Другое (водительские права, место проживания, гражданство, загранпаспорт)',
            'TODO': 'Обязанности сотрудника на данной позиции',
            'NEEDED': 'Требования к сотруднику на данной позиции',
            'FORLANGLEVEL': 'Степень владения иностранным языком',
            'INSTITUTE': 'Название учебного заведения',
            'EDUNEEDED': 'Степень необходимости',
            'HISTNEWOROLD': 'Новая или старая позиция',
            'HISTWHYAPPEAR': 'Причины появления позиции',
            'HISTNUMCANDBEFORE': 'Количество кандидатов',
            'STATCHIEFFIO': 'Фамилия И.О.',
            'STATCHIEFDOLG': 'Должность',
            'NAJMVALTYPE': 'Вид валюты',
            'NAJMSALARY': 'Зарплата'
        },
        'PrjSomeForm': {
            'Company': 'Относится к',
            'Text': 'Текст документа',
            'createdate': 'Дата заполнения',
            'sekrfio': 'Секретарь по вводу информации',
            'sekrdate': 'Дата',
            'sekrworkname': 'Выполнил(а) работу:',
        },
        'OrgSomeForm': {
            'Company': 'Относится к',
            'Text': 'Текст документа',
            'createdate': 'Дата заполнения',
            'sekrfio': 'Секретарь по вводу информации',
            'sekrdate': 'Дата',
            'sekrworkname': 'Выполнил(а) работу:',
        },
        'SomeFormMain': {
            'company': 'Компания',
            'project': 'Проект',
            'Text': 'Текст',
        },
        'PplCV': {
            'family': 'Фамилия',
            'name': 'Имя',
            'secname': 'Отчество',
            'bithday':'Дата рождения',
            'sex': 'Пол',
            'town': 'Город',
            'adres': 'Адрес проживания',
            'hometel': 'Домашний телефон',
            'contacttel': 'Контактный телефон',
            'worktel': 'Служебный телефон',
            'email': 'E-mail',
            'orgname': 'Компания',
            'dolg': 'Должность',
            'begwork': 'в последнем месте работал(а) с',
            'endwork': 'в последнем месте работал(а) по',
            'terminology': 'Специальная лексика',
            'createdate': 'Дата заполнения',
            'sekrfio': 'Фамилия И.О. телефонного секретаря',
            'sekrdate': 'Дата',
            'sekrworkname': 'Выполнил(а) работу',
            'index': 'Почтовый индекс',
            'region': 'Страна',
            'worktelcode': 'Код служебного телефона',
            'hometelcode': 'Код домашнего телефона',
            'contacttelcode': 'Код контактного телефона',
            'mobtel': 'Мобильный телефон',
            'level': 'Степень владения иностранным языком',
            'faks': 'Факс',
            'fakscode': 'Код факса',
            'metro': 'Ближайшая станция метро'
        },
        'PplAnketa': {
            'lname': 'Фамилия',
            'fname': 'Имя',
            'sname': 'Отчество',
            'full-name': 'Фамилия И.О.',
            'birth-date': 'Дата рождения',
            'sex': 'Пол',
            'citizenship': 'Гражданство',
            'haveavtoroles': 'Водительские права',
            'haveavto': 'Наличие авто',
            'avtoexperience': 'Стаж вождения (лет)',
            'avtoexpert': 'Категория прав',
            'cancomputer': 'Наличие навыков работы на компьютере',
            'canprograms': 'Навыки работы на компьютере',
            'canprofdevice': 'Наличие опыта работы на спец. и проф. оборудовании',
            'profdevice': 'Опыт работы на спец. и проф. оборудовании',
            'city': 'Город проживания',
            'address': 'Адрес проживания',
            'contact-phone': 'Контактный телефон',
            'contacttelcode': 'Код контактного телефона',
            'wantpost': 'Требования к должности',
            'organization': 'Организация',
            'begin-date': 'Начало работы (мес/год)',
            'worktype': 'Тип организации',
            'position': 'Должность',
            'function': 'Должностные обязанности',
            'institution': 'Учебное заведение',
            'education-begin': 'Год начала',
            'education-end': 'Год окончания',
            'education-level': 'Уровень образования',
            'education-form': 'Форма обучения',
            'education-type': 'Тип',
            'speciality': 'Специальность, квалификация по диплому',
            'createdate': 'Дата заполнения',
            'sekrfio': 'Фамилия И.О. телефонного секретаря',
            'sekrdate': 'Дата',
            'sekrworkname': 'Выполнил(а) работу',
            'family-status': 'Семейное положение',
            'zipcode': 'Почтовый индекс',
            'country': 'Страна проживания',
            'home-phone': 'Домашний телефон',
            'email': 'E-mail',
            'edutype': 'Тип образования',
            'name': 'Название спец. школы, аспирантуры, стажировки, курсов, семинаров',
            'hometelcode': 'Код домашнего телефона',
            'phone': 'Телефон рекомендателя',
            'native-language': 'русский',
            'children-count': 'Количество детей',
            'worldpasport': 'Имеется ли загранпаспорт',
            'travelfreq': 'Возможная частота командировок',
            'wantcompany': 'Направление деятельности компании, виды товаров, услуг, с которыми хотелось бы работать',
            'wantsalary': 'Минимальный уровень зарплаты (в USD)',
            'wantwork': 'Требования к должностным обязанностям',
            'wantadd': 'Дополнительные требования (размеры компании, страна происхождения, месторасположение и т.д.)',
            'end-date': 'Окончание работы (мес/год)',
            'activity-direction': 'Направление деятельности организации',
            'achievement': 'Конкретные примеры достижений',
            'finding-new-job-reason': 'Причины поиска новой работы',
            'faculty': 'Факультет',
            'level': 'Уровень владения',
            'numhelper': 'Количество подчиненных',
            'canprint': 'Владение машинописью',
            'rusprintznmin': 'Скорость печати на русском (знаков/мин)',
            'mob-phone': 'Мобильный телефон',
            'wantsalaryform': 'Форма оплаты',
            'wherestrong': 'Укажите в какой из областей Вы наиболее сильны профессионально',
            'wanttemp': 'Согласны ли на временную работу?',
            'wanttempworkday': 'Режим работы',
            'wanttempweekday': 'Удобные рабочие дни',
            'wanttempworkhours': 'Часы работы',
            'canworktempatfirstday': 'Можете ли Вы приступить к работе в тот же день, как только мы свяжемся с Вами',
            'work-phone': 'Служебный телефон',
            'subway-station': 'Ближайшая станция метро',
            'department': 'Подразделение',
            'children-age': 'Возраст детей',
            'worktelcode': 'Код служебного телефона',
            'wantworkday': 'Рабочий день',
            'eduotdelenie': 'Отделение',
            'compcountry': 'Страна происхождения организации',
            'chieffam': 'Фамилия непосредственного начальника',
            'chiefname': 'Имя непосредственного начальника',
            'chiefname2': 'Отчество непосредственного начальника',
            'chiefdolg': 'Должность непосредственного начальника',
            'wanttempmonthsalary': 'Зарплатные ожидания (в USD net) в месяц при временной работе',
            'latprintznmin': 'Скорость печати на латинском (знаков/мин)',
            'worksize': 'Размер организации',
            'useavto': 'Могу использовать личный автомобиль в служебных целях',
            'institute': 'Учебное заведение',
            'year_graduation': 'Год окончания',
            'month_graduation': 'Месяц окончания',
            'town': 'Город',
            'street': 'Улица',
            'type': 'Адрес фактического/прописки',
            'ACHIEVEMENTS': 'Опишите Ваше самое большое достижение на данный момент, которое вызывает у Вас чувство гордости',
            'medbook': 'Наличие медицинской книжки',
            'rusprintmethod': 'Метод печати русских символов',
            'latprintmethod': 'Метод печати латиницы',
            'rus-lang-level': 'Уровень Русского языка',
            'eng-lang-level': 'Уровень Английского языка',
            'military': 'Воинская обязанность',
            'children': 'Дети',
            'bad-habits': 'Вредные привычки',
            'conviction': 'Судимость',
            'pc-level': 'Владение ПК',
            'personal-car': 'Личный автомобиль',
            'use-personal-car': 'Готовность использовать личное авто',
            'spec-tech': 'Управление спец. техникой',
            'work-permissions': 'Допуски к работе',
            'medical-book': 'Мед. книжка',
            'int-passport': 'Загр. паспорт',
            'time-sheet': 'График работы',
            'work-type': 'Тип занятости',
            'time-to-work': 'Время до работы',
            'ready-to-move': 'Переезд',
            'businesstrip': 'Командировки',
            'work-experience': 'Опыт работы',
            'feedback': 'Форма обратной связи',
            'desired-position': 'Желаемая позиция',
            'wait-money': 'Зарплатные ожидания',
            'birthPlace': 'Место рождения',
            'computerSkills': 'Владение компьютерными программами',
            'NISSAN_HEAD_FULLNAME': 'ФИО',
            'NISSAN_HEAD_POSITION': 'Должность руководителя',
            'NISSAN_HEAD_PHONE': 'Телефон руководителя',
            'NISSAN_HEAD_EMAIL': 'Почта руководителя',
            'workFunction': 'Основные обязанности',
            'competenceName': 'Название компетенции',
            'competenceValue': 'Оценка',
            'nissanInstitute': 'ВУЗ',
            'nissanEducationDate': 'Год/месяц окончания',
            'nissanSpeciality': 'Специальность',
            'nissanEdicationLevel': 'Квалификация',
            'title': {
                'form': 'Анкета',
                'residenceAddress': 'Адрес проживания',
                'phones': 'Телефоны',
                'contacts': 'Связь',
                'education': 'Высшее и среднее специальное образование',
                'nissanEducation': 'Образование, курсы',
                'landingData': 'Данные с лендинговой страницы',
                'workExperience': 'Опыт работы',
                'head': 'Руководитель',
                'competence': 'Компетенции',
            }
        },
        'OrgMrktCallData': {
            'SOTRNAME':               'Сотрудник',
            'PPLNAME':                'Сотрудник клиента',
            'ORGNAME':                'Компания-клиент',
            'DATE':                   'Дата',
            'PPLDOLG':                'Должность сотрудника клиента',
            'ABOUTSPEAK':             'Содержание разговора',
            'SIGN':                   'Впечатления о собеседнике и доп.информация',
            'RESULT':                 'О чем договорились',
            'TYPE':                   'Тип',
            'TARGET':                 'Цель маркетингового контакта',
            'ADDANCORSOTR':           'Также участвовали',
            'ADDZAKSOTR':             'Также участвовали со стороны клиента',
            'ORGKATEGOR':             'Категория клиента',
            'INFABOUT':               'Источник информации для маркетинга',
            'NEXTDATE':               'Дата',
            'NEXTCNTTYPEST':          'Тип',
            'NEXTCNT_SOTRNAME':       'Ответственный',
            'TARGETDESCR':            'Комментарий',
            'title': {
                marketingContact: 'Маркетинговый контакт',
                client: 'Клиент',
                selfParticipants: 'Участники встречи/разговора со стороны компании',
                clientParticipants: 'Участники встречи/разговора со стороны клиента',
            }
        },
        test: {
            name: 'Название',
            score: 'Значение',
            id: 'ID',
            scales: {
                'PCTL': 'Процентиль',
                'GRADE': 'Грейд',
                'T': 'Т-балл',
            },
        },
        resume: {
            'about': 'О себе',
            'email': 'Email',
            'education': 'Образование',
            'addinfo': 'Дополнительная информация',
            'address': 'Адрес',
            'birthday': 'Дата рождения',
            'businesstrip': 'Командировки',
            'citizen': 'Гражданство',
            'experience': 'Опыт',
            'first_name': 'Имя',
            'im':'Мессенджер',
            'language': 'Языки',
            'last_name': 'Фамилия',
            'lastupdate': 'Последнее обновление',
            'metro': 'Метро',
            'middle_name': 'Отчество',
            'own_url': 'Личный сайт',
            'phone': 'Телефон',
            'relocation': 'Возможность переезда',
            'sex': 'Пол',
            'skill': 'Навыки и знания',
            'wait_status': 'Желаемая позиция',
            'wait_money': 'Зарплатные ожидания'
        },
        title: {
            personImpression: 'Впечатление о человеке',
            profExperience: 'Профессиональный опыт',
            salary: 'Зарплатные ожидания',
            profMotivation: 'Профессиональныя мотивация',
            jobSearchHistory: 'История поиска работы',
            interviewConsolution: 'Выводы по результатам интервью',
            alsoParticipated: 'Также участвовали',
            additionalComments: 'Дополнительные комментарии',
            cardEdited: 'Карточку редактировали',
            managerInfo: 'Информация от контактного лица',
            candidateInfo: 'Информация от кандидата',
            interview: 'Интервью',
            recomendation: 'Проверка рекомендаций',
            forLineManager: 'Сделано для линейного менеджера',
            recommender: 'Рекомендатель',
            coopWorkPeriod: 'Период совместной работы',
            subordinationSystem: 'Система подчинения «кандидат/рекомендатель»',
            mainTasks: 'Основные задачи и функции кандидата',
            workResults: 'Результат работы и достижения',
            strength: 'Сильные стороны',
            managment: 'Руководство людьми',
            weakSides: 'Слабые стороны и области для развития',
            peopleRelations: 'Отношения с людьми',
            workAttitude: 'Отношение к работе',
            futureLeader: 'Будущий руководитель',
            dismissalReasons: 'Причины увольнения/желания рассматривать',
            workDesire: 'Желание работать с кандидатом снова',
            complianceFutureWork: 'Соответствие будущей работе',
            additionalInformation: 'Дополнительная информация о кандидате',
            yourQuestion: 'Свой доп. вопрос или специфический вопрос линейного менеджера',
            marketing: 'Маркетинговый контакт',
            conversationСontent: 'Содержание разговора',
            interlocutorImpression: 'Впечатление о собеседнике и доп.информация',
            nextContact: 'Следующий контакт',
        }
    }
};
